<template>
  <div>
    <el-input
        v-model="textarea"
        :rows="2"
        placeholder="请输入内容"
        type="textarea">
    </el-input>
    <el-button type="primary" @click="href">苹果跳转</el-button>
    <el-button type="primary" @click="openWechatPay">安卓跳转</el-button>
  </div>
</template>

<script>
export default {
  name: "adc",
  data() {
    return {
      textarea: ''
    }
  },
  methods: {
    href() {
      window.location.href = this.textarea
    },
    openWechatPay() {
      const wechatPayUrl = this.textarea

      const pathParts = this.textarea.split('/');

      const appId = pathParts[3];


      const intentUrl = `intent://app/${appId}/pay/?${wechatPayUrl.split('?')[1]}#Intent;scheme=weixin;package=com.tencent.mm;end`;

      // 尝试用 Intent 跳转
      window.location.href = intentUrl;

      // 如果跳转失败，提示用户手动操作
      setTimeout(() => {
        if (!document.hidden) {
          alert("跳转失败，请手动复制链接到微信打开：" + wechatPayUrl);
        }
      }, 1000);
    },
    onBridgeReady() {
      WeixinJSBridge.invoke('getBrandWCPayRequest', {
            "appId": "wx2421b1c4370ec43b",     //公众号ID，由商户传入
            "timeStamp": "1395712654",     //时间戳，自1970年以来的秒数
            "nonceStr": "e61463f8efa94090b1f366cccfbbb444",      //随机串
            "package": "prepay_id=wx21201855730335ac86f8c43d1889123400",
            "signType": "RSA",     //微信签名方式：
            "paySign": "oR9d8PuhnIc+YZ8cBHFCwfgpaK9gd7vaRvkYD7rthRAZ\/X+QBhcCYL21N7cHCTUxbQ+EAt6Uy+lwSN22f5YZvI45MLko8Pfso0jm46v5hqcVwrk6uddkGuT+Cdvu4WBqDzaDjnNa5UK3GfE1Wfl2gHxIIY5lLdUgWFts17D4WuolLLkiFZV+JSHMvH7eaLdT9N5GBovBwu5yYKUR7skR8Fu+LozcSqQixnlEZUfyE55feLOQTUYzLmR9pNtPbPsu6WVhbNHMS3Ss2+AehHvz+n64GDmXxbX++IOBvm2olHu3PsOUGRwhudhVf7UcGcunXt8cqNjKNqZLhLw4jq\/xDg==" //微信签名
          },
          function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠，商户需进一步调用后端查单确认支付结果。
            }
          });
    }
  }
}
</script>

<style scoped>

</style>